import ApiService from "./api.service";

const prepareFormSearch = function (form) {
  let query = {}
  if (form.q !== '') query.q = form.q;
  if (form.status !== '') query.status = form.status;
  if (form.company !== '') query.company = form.company;
  if (form.owner !== '') query.owner = form.owner;
  if (form.year !== '') query.year = form.year;
  return query
}

export const Construction = {
  search: async function (form) {
    let response = await ApiService.get("/constructions", prepareFormSearch(form));
    return response.data.constructions;
  },
  searchDivision: async function (form) {
    let response = await ApiService.get("/constructions/division", prepareFormSearch(form));
    return response.data.constructions;
  },
  create: async function (query) {
    let response = await ApiService.post("/construction", query);
    return response.data;
  },
  update: async function (construction_id, data) {
    let response = await ApiService.put("/construction/" + construction_id, data);
    return response.data;
  },
  loadInfoById: async function (construction_id) {
    let response = await ApiService.get("/construction/" + construction_id+"/info");
    return response.data;
  },
  loadById: async function (construction_id) {
    let response = await ApiService.get("/construction/" + construction_id);
    return response.data;
  },
  remove: async function (construction_id) {
    let response = await ApiService.delete("/construction/" + construction_id);
    return response;
  },
  offerprice: async function (construction_id, offer_price) {
    await ApiService.patch("/construction/" + construction_id + "/offerprice", {
      offer_price: offer_price
    });
    return;
  },
  subcontractors: async function (construction_id, subcontractors) {
    await ApiService.patch("/construction/" + construction_id + "/subcontractors", {
      subcontractors: subcontractors
    });
    return;
  },
  status: async function (construction_id, newStatus) {
    let response = await ApiService.patch("/construction/" + construction_id + "/status", {
      status: newStatus
    });
    return response.data;
  },
  setDate: async function (construction_id, query) {
    let response = await ApiService.patch("/construction/" + construction_id + "/setdate", query);
    return response.data;
  },
  subcontractor: async function (construction_id, query) {
    let response = await ApiService.patch("/construction/" + construction_id + "/subcontractor", query);
    return response.data;
  },
  manager: async function (construction_id, user_id) {
    await ApiService.patch("/construction/" + construction_id + "/manager", {
      user_id: user_id
    });
  },
  available: async function () {
    let response = await ApiService.get("/constructions/available");
    return response.data.constructions;
  },
  getMaterials: async function(id) {
    let response = await ApiService.get(`/construction/${id}/materials`);
    return response.data.materials;
  },
};

export default Construction;